<template>
    <div class="row">
        <div class="form-group col-12">
            <label for="name">Parent Category</label>
            <v-select
                v-model="item.parentCategory"
                label="name"
                :options="articleCategories"
                :class="{
                    'is-invalid': !!getError('parentCategoryId')
                }"
                @search="onArticleCategoriesSearch"
                @input="onArticleCategoriesChange"
            >
                <template #no-options="{ search }">
                    {{
                        search
                            ? 'Sorry, no matching options.'
                            : 'Type to search...'
                    }}
                </template>
            </v-select>

            <div class="invalid-feedback">
                {{ getError('parentCategoryId') }}
            </div>
        </div>

        <form-input
            v-model="item.name"
            label="Name"
            :error-message="getError('name')"
            placeholder="Name"
            @blur="$emit('on-name-change', item.name)"
        />

        <form-input
            v-model="item.description"
            label="Description"
            :error-message="getError('description')"
            placeholder="Description"
        />

        <div
            v-if="item.content"
            :key="item.parentCategoryId"
            class="form-group col-12"
        >
            <component
                :is="`${
                    item.parentCategoryId ? 'subcategory' : 'category'
                }-content`"
                v-model="item.content"
            />
        </div>

        <div v-if="!item.parentCategoryId" class="form-group col-12">
            <tabs-section ref="tabsSection" v-model="item.tabs" show-title />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';

import BaseForm from '@/components/elements/BaseForm';
import TabsSection from '@/components/article-categories/TabsSection';
import CategoryContent from '@/components/contents/pages/CategoriesPage';
import SubcategoryContent from '@/components/contents/pages/SubcategoriesPage';

export default {
    components: {
        TabsSection,
        CategoryContent,
        SubcategoryContent
    },

    extends: BaseForm,

    data() {
        const commonCategoryTypeContent = {
            hero: {
                image: null,
                mobileImage: null,
                limitWidth: true
            },
            introductionSection: {
                title: 'Title',
                description: '<p>Description</p>',
                buttons: [
                    {
                        title: 'Title',
                        description: 'Description',
                        image: null,
                        link: '/',
                        isHidden: false
                    }
                ]
            },
            videoSection: {
                youtube: null,
                title: 'Title',
                video: null
            }
        };

        const categoryContent = {
            ...commonCategoryTypeContent,
            moreInformation: {
                title: 'Title',
                items: []
            }
        };
        const subcategoryContent = {
            ...commonCategoryTypeContent,
            buttons: [{ text: '', link: '/' }],
            moreInformation: {
                isHidden: false,
                title: 'Title',
                items: []
            }
        };

        return {
            parentCategory: {},
            articles: [],
            articleCategories: [],
            categoryContent,
            subcategoryContent
        };
    },

    computed: {
        parentCategorySlug() {
            return this.item.parentCategory?.slug;
        }
    },

    async mounted() {
        if (this.item.id && this.item.content.moreInformation?.items) {
            const { rows } = await this.getInformationByCategoryId(
                this.item.id
            );

            this.item.content.moreInformation.items = rows;
        }
    },

    methods: {
        ...mapActions({
            fetchArticleCategories: 'articleCategories/index',
            getInformationByCategoryId:
                'articleCategories/getInformationByCategoryId'
        }),

        async onArticleCategoriesSearch(search, loading) {
            if (!search.length) {
                this.articleCategories = [];

                return;
            }

            if (this.timer) {
                clearTimeout(this.timer);

                this.timer = null;
            }

            loading(true);

            this.timer = setTimeout(async () => {
                const filters = {};

                if (this.item?.id) {
                    filters.id = {
                        value: this.item.id,
                        type: 'not'
                    };
                }

                try {
                    const { rows } = await this.fetchArticleCategories({
                        search,
                        filters,
                        perPage: 50
                    });

                    this.articleCategories = rows;
                } catch (err) {
                    console.error(err);
                } finally {
                    loading(false);
                }
            }, 500);
        },

        onArticleCategoriesChange(articleCategory) {
            const oldParentCategoryId = this.item.parentCategoryId;

            const content =
                oldParentCategoryId && articleCategory?.id
                    ? this.item.content
                    : cloneDeep(
                          articleCategory?.id
                              ? this.subcategoryContent
                              : this.categoryContent
                      );

            this.item = {
                ...this.item,
                parentCategoryId: articleCategory?.id || null,
                content,
                tabs: []
            };
        }
    }
};
</script>
